import {useEffect, useRef} from "react";
import {ISlsOrd} from "../kova/slsordClient";
import {useStateId} from "../hooks/useStateId";
import {useVisualizerSession} from "../components/visualizer/VscVisualizerSession";
import {ILevelGroupSetting} from "../components/visualizer/VisualizerSessionManager";

export function getUnrealId(slsOrd:ISlsOrd) {
    return `b${slsOrd.blockNumber}l${slsOrd.lotNumber}`;
}

interface IBigScreen3D {
    camera:string|null;
    items: IBigScreenCommunity3DItems[];

    /**
     * If specified, then there will be a car parked on the parking spot of a specific ISlsOrd. The second element is the car type,
     *
     */
    parkedCar?: [ISlsOrd, "EV"|"Gas"];

}

function useLevelGroups(items: IBigScreenCommunity3DItems[]) {

    const levelGroups: ILevelGroupSetting[] = [];

    for (const item of items) {
        const slsOrd = item.slsOrd;
        // We only touch sales orders which are available - sold sales orders should still have their roof on //
        if (!slsOrd.isSold) {
            levelGroups.push({lot: getUnrealId(slsOrd), levelGroup: item.levelGroup});
        }
    }
    return levelGroups;
}

export function useCamera(cameraId: string|null) {
    const visualizer = useVisualizerSession();
    useEffect(() => {
        if (cameraId === null) return;
        visualizer.changeCamera(cameraId);
    }, [cameraId, visualizer]);

}
export interface IHouseModelSetting {
    houseModel:string;
    lotId:string;
}
export const BigScreen3D: React.FC<{camera:string|null, levelGroups: ILevelGroupSetting[], lotLabels?: ILotLabel[], parking?: IParking[], houseModels?: IHouseModelSetting[]}> = (props) => {

    const { camera, levelGroups, lotLabels, parking, houseModels } = props;
    const sessionId = useStateId([JSON.stringify({camera, levelGroups, lotLabels})]);
    const visualizerSession = useVisualizerSession();

    useEffect(() => {
        if (camera === null) return;
        visualizerSession.show3d(sessionId, {
            houseModels,
            camera,
            levelGroups: levelGroups,
            lotLabels,
            parking
        });
    }, [camera, visualizerSession, sessionId]);
    return null;
}
export interface IParking {
    lot: string;
    show: boolean;

}
export interface ILotLabel {
    lot: string;
    label: string;
    color: string;
}
function useLotLabels(items: IBigScreenCommunity3DItems[]) {
    const retval: ILotLabel[] = [];
    for (const item of items) {
        const so = item.slsOrd;
        if (so.isSold) {
            retval.push({
                lot: getUnrealId(so),
                label: "Sold",
                color: "Red"
            });

        } else {
            retval.push({
                lot: getUnrealId(so),
                label: so.lotNumber,
                color: "Green"
            });
        }
    }
    return retval;
}
export interface IBigScreenCommunity3DItems {
    slsOrd: ISlsOrd;
    levelGroup: string;
    showParking: boolean;
}
function useParking2(items:IBigScreenCommunity3DItems[]) {
    const retval: IParking[] = [];

    for (const item of items) {
        retval.push({lot: getUnrealId(item.slsOrd), show: item.showParking});

    }
    return retval;
}
const BigScreenCommunity3D: React.FC<IBigScreen3D> = ({camera, items,  parkedCar}) => {
    useCamera(camera);
    const levelGroups = useLevelGroups(items);
    const lotLabels = useLotLabels(items);
    const parking = useParking2(items);
    return <BigScreen3D camera={camera} levelGroups={levelGroups} lotLabels={lotLabels} parking={parking} />;

}
export default BigScreenCommunity3D;